export default __webpack_public_path__ + "static/media/chevron-down-blue.2f70ed4a.svg";